import { orgAPI } from "@/api/api";
import type { IntegrationConnection } from "@cohesive/api-client";
import type { SlackUserEntity } from "@cohesive/api-entities";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

interface UseSlackUsersListProps {
  connection: IntegrationConnection;
  options?: Partial<UseQueryOptions<SlackUserEntity[], Error>>;
}

export function isSlackUserEntity(entity: any): entity is SlackUserEntity {
  return entity.type === "slack_user";
}

export function useSlackUsersList({
  connection,
  options = {},
}: UseSlackUsersListProps) {
  return useQuery<SlackUserEntity[]>({
    queryKey: ["slack-users-list", connection?.id],
    queryFn: async () => {
      const response = await orgAPI.toolbox.execute<
        SlackUserEntity[],
        Record<string, unknown>
      >({
        integration_connection_id: connection?.id!,
        action_name: "slack-users-list",
        action_input: {},
      });

      return response.data;
    },
    enabled: !!connection?.id,
    staleTime: 1000 * 60, // 1 minute
    ...options,
  });
}
